import {
  CalculatedBalances,
  CalculatedBalancesGroupedTwice,
  CalculatedBalanceCollection,
  CalculatedBalanceParams,
} from "@bitwarden/web-vault/app/services/store/calculated-balance.collection.abstraction";
import { signal } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { AccountSymbolBalanceMap } from "@bitwarden/web-vault/app/models/types/scenario-group.types";
import { BalanceDatesUtils } from "@bitwarden/web-vault/app/services/store/calculation-base/balances/balanceDates.utils";

export class BalanceByAccountsAndSymbolsCalculatedCollection extends CalculatedBalanceCollection {
  protected readonly type = "BalanceByAccountsAndSymbols";
  protected calculations: CalculatedBalancesGroupedTwice = new Map<string, CalculatedBalances>();

  protected _balances = signal<AccountSymbolBalanceMap>(new Map());
  readonly balances = this._balances.asReadonly();
  balances$ = toObservable(this.balances);

  async updateCalculations(parameters: CalculatedBalanceParams): Promise<void> {
    const isStale = this.staleCheck();
    let todayDate = parameters?.period?.endDate ? parameters.period.endDate : new Date();
    todayDate = BalanceDatesUtils.getEndOfDayDate(new Date());
    const balancesByAccountSymbols: Record<
      number,
      Record<string, number>
    > = await this.getBalanceByAccountsSymbols(
      parameters.webWorkerQueue,
      parameters.calculatedTransactions,
      todayDate,
    );

    if (isStale()) {
      return;
    }
    this.setBalances(balancesByAccountSymbols);
  }

  getCalculations(): CalculatedBalancesGroupedTwice {
    return this.calculations;
  }

  protected clearCalculations(): void {
    this.calculations.clear();
    this._balances.set(null);
  }

  triggerChanges(): void {}

  private setBalances(balancesByAccountSymbols: Record<number, Record<string, number>>): void {
    this.calculations = new Map();

    for (const [account, balancesBySymbol] of Object.entries(balancesByAccountSymbols)) {
      const balancesBySymbolMap = new Map(Object.entries(balancesBySymbol));
      this.calculations.set(account, balancesBySymbolMap);
    }
    this._balances.set(this.calculations);
  }
}
